import React from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { MaxBotPerRent, RentSubscriptions, SUB_STATUS, SUB_TIER } from "../../../Const";
import { getMonthlyPrice, getYearlyPrice } from "../../../utils/SubUtils";
import "./RentBotPremiumInfo.scss";
import { RentPlans } from "../../../Const";
import TutorialPopup from "../../help/TutorialPopup";
import { useTranslation } from "react-i18next";
import { trimString } from "../../../utils/Utils";

const RentBotPremiumInfo = (props) => {
  const {
    template,
    plan
  } = props;
  
  const history = useHistory();
  const {t} = useTranslation()

  
  return (
    <>
    <div className="marketplace-card subscription">
       <div className="pos-relative marketplace-card-content">
        <img src={template.image} className=""></img>
        <div className="marketplace-card-info-container">
          <p className="marketplace-card-title text-center w-100">{trimString(template.title,50) }</p>
          <div className="">
                <div className="w-100 d-flex justify-content-between mt-4">
                  <div className="text-center w-100 font-weight-bold">US ${template[RentSubscriptions[plan]]} / {t(RentPlans[plan])}</div>
                </div>
                <div className="w-100 d-flex justify-content-between mt-2">
                  <div className="text-center w-100 mt-4"> <i className="fas fa-check-circle item-check success"></i>{" "}
             {MaxBotPerRent} <span className="light-text"></span>{t("active-bots")}<TutorialPopup content={t("max-bot-msg", {maxBot: MaxBotPerRent})} /></div>
                </div>
               
          </div>
        </div>
      </div>
    </div>
    
    </>
    
  );
};

export default RentBotPremiumInfo;
